import $ from 'jquery';

import { Direction } from 'webapp/enums/enums';
import { TourId } from 'webapp/enums/tour';
import { TrackingEvent } from 'webapp/enums/tracking';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';

export default class ReportsPagelessAddColumnTour extends TourBase {
	static keyForPersistantDone = UserSettingsKey.REPORTS_PAGELESS_ADD_COLUMN;
	override trackEvent: TrackingEvent | '' = TrackingEvent.BUBBLE_REPORTS_PAGELESS_ADD_COLUMN;

	get id(): string {
		return TourId.REPORTS__PAGELESS_ADD_COLUMN;
	}

	override get keyForPersistantDone(): string {
		return ReportsPagelessAddColumnTour.keyForPersistantDone;
	}

	override get stepData(): StepData[] {
		return [
			{
				direction: Direction.UP,
				allowStacked: false,
				attachTo: () => {
					// Target the "Add column" button that appears after adding a non-title fragment
					// Look for grid items that are not title fragments and get their add column button
					const nonTitleGridItems = $('.grid-item').filter(function () {
						return !$(this).find('.fragment--title').length;
					});
					return nonTitleGridItems
						.find('.grid-item-resizer .add-fragment--column .add-fragment-button')
						.first();
				},
				scrollToAttachTo: true,
			},
		];
	}

	override start(): void {
		super.start();
		this.markDone(); // just one step, once seen, it's done
	}

	override onExplicitClose(): void {
		// User manually closed - mark all pageless tours as done
		this.flowTourReportsPagelessService.endAllTours();
		super.onExplicitClose();
	}
}
